(() => {
  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => [...r.querySelectorAll(s)];

  const formatMoney = (cents) => {
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, theme.moneyFormat);
    return (cents / 100).toFixed(2);
  };
  const formatCartMoney = (cents) => {
    const currency = window.Shopify?.currency?.active || 'TRY';
    if (currency === 'TRY') {
      const amount = cents / 100;
      return `${amount.toLocaleString('tr-TR', {
        minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      })}₺`;
    }
    return formatMoney(cents);
  };
  const escapeHTML = (value = '') => String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  /* Drawers */
  const syncDrawerLock = () => {
    document.body.classList.toggle('drawer-open', Boolean(qs('.drawer.is-open')));
  };
  // Sticky .site-header is a containing/stacking context. Fixed drawers inside it
  // stay trapped on phones, so park them on the body before they open.
  const releaseDrawer = (drawer) => {
    if (!drawer) return;
    if (drawer.closest('.site-header')) document.body.appendChild(drawer);
    drawer.querySelector('.drawer__panel')?.style.removeProperty('transform');
  };
  qsa('.site-header .drawer').forEach(releaseDrawer);
  const openDrawer = (id) => {
    const drawer = qs(id);
    if (!drawer) return;
    releaseDrawer(drawer);
    drawer.classList.add('is-open');
    syncDrawerLock();
  };
  const closeDrawer = (el) => {
    el?.classList.remove('is-open');
    syncDrawerLock();
  };
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-open-drawer]');
    if (open) {
      e.preventDefault();
      const target = open.getAttribute('data-open-drawer');
      if (target === '#CartDrawer') refreshCart();
      openDrawer(target);
    }
    if (e.target.closest('[data-close-drawer]') || e.target.classList.contains('drawer__overlay')) {
      closeDrawer(e.target.closest('.drawer'));
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer(qs('.drawer.is-open'));
  });

  /* Product-card media switcher for touch screens */
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-card-media-toggle]');
    if (!toggle) return;
    e.preventDefault();
    const card = toggle.closest('.card');
    const showingSecondary = card?.classList.toggle('show-secondary');
    toggle.setAttribute('aria-pressed', showingSecondary ? 'true' : 'false');
  });

  /* Cart */
  const cartCount = () => qsa('[data-cart-count]');
  const refreshCart = async () => {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    cartCount().forEach((n) => { n.textContent = cart.item_count; n.hidden = cart.item_count === 0; });
    const root = qs('[data-cart-drawer-body]');
    if (!root) return;
    const drawer = qs('#CartDrawer');
    drawer?.classList.toggle('is-empty', !cart.items.length);
    const drawerCount = qs('[data-cart-drawer-count]');
    if (drawerCount) drawerCount.textContent = cart.item_count;
    if (!cart.items.length) {
      root.innerHTML = `
        <div class="cart-drawer__empty">
          <span aria-hidden="true">○</span>
          <h2>Sepetin şu an boş.</h2>
          <p>Günlük rutinine uygun SAINT CLAIR formülünü keşfet.</p>
          <a class="btn btn--fill" href="/collections/all">Ürünleri gör</a>
        </div>`;
    } else {
      root.innerHTML = `<div class="cart-drawer__items">${cart.items.map((item) => `
        <article class="cart-drawer__item" data-key="${escapeHTML(item.key)}" data-cart-product-id="${item.product_id}">
          <a class="cart-drawer__item-image" href="${escapeHTML(item.url)}">
            <img src="${escapeHTML(item.image || '')}" alt="${escapeHTML(item.product_title)}">
          </a>
          <div class="cart-drawer__item-copy">
            <a href="${escapeHTML(item.url)}">${escapeHTML(item.product_title)}</a>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<small>${escapeHTML(item.variant_title)}</small>` : ''}
            <strong>${formatCartMoney(item.final_line_price)}</strong>
            <div class="cart-drawer__qty">
              <button type="button" data-qty-change="-1" aria-label="Adedi azalt">−</button>
              <input value="${item.quantity}" readonly aria-label="Adet">
              <button type="button" data-qty-change="1" aria-label="Adedi artır">+</button>
            </div>
          </div>
          <button class="cart-drawer__remove" type="button" data-remove aria-label="Ürünü kaldır">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 7h14M9 7V4h6v3M7 7l1 13h8l1-13M10 11v5M14 11v5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </button>
        </article>`).join('')}</div>`;
    }
    const sub = qs('[data-cart-subtotal]');
    if (sub) sub.textContent = formatCartMoney(cart.total_price);
    const bar = qs('[data-ship-bar]');
    if (bar) {
      const max = Number(bar.dataset.threshold || 0) * 100;
      const pct = max ? Math.min(100, (cart.total_price / max) * 100) : 100;
      bar.querySelector('span').style.width = pct + '%';
      const shippingMessage = qs('[data-shipping-message]');
      if (shippingMessage) {
        shippingMessage.textContent = cart.total_price >= max
          ? 'Ücretsiz kargo kazandın'
          : `${formatCartMoney(Math.max(0, max - cart.total_price))} kaldı`;
      }
    }
    const productIds = new Set(cart.items.map((item) => String(item.product_id)));
    qsa('[data-upsell-product-id]').forEach((card) => {
      card.hidden = productIds.has(card.dataset.upsellProductId);
    });
    const bundleBar = qs('[data-bundle-bar]');
    if (bundleBar) bundleBar.style.width = `${Math.min(100, cart.item_count * 25)}%`;
    const bundleMessage = qs('[data-bundle-message]');
    if (bundleMessage) {
      bundleMessage.textContent = cart.item_count >= 4
        ? 'Kampanya aktif · 1 ürün bizden'
        : `Ücretsiz ürün için ${4 - cart.item_count} ürün daha ekle`;
    }
  };

  const changeCart = async (key, qty) => {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    refreshCart();
  };

  document.addEventListener('click', async (e) => {
    const addon = e.target.closest('[data-cart-addon]');
    if (addon) {
      addon.classList.add('is-loading');
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(addon.dataset.variantId), quantity: 1 })
      });
      await refreshCart();
      addon.classList.remove('is-loading');
      return;
    }
    const row = e.target.closest('[data-key]');
    if (!row) return;
    if (e.target.closest('[data-remove]')) {
      changeCart(row.dataset.key, 0);
      return;
    }
    const btn = e.target.closest('[data-qty-change]');
    if (btn && row.matches('.cart-drawer__item, .cart-item')) {
      const input = row.querySelector('input');
      changeCart(row.dataset.key, Math.max(0, Number(input.value) + Number(btn.dataset.qtyChange)));
    }
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    if (theme.cartType !== 'drawer') return;
    e.preventDefault();
    const data = new FormData(form);
    await fetch('/cart/add.js', { method: 'POST', body: data });
    await refreshCart();
    openDrawer('#CartDrawer');
  });

  /* PDP mix-and-match — 4 al, 3 öde */
  qsa('[data-pdp-builder]').forEach((builder) => {
    const goal = Number(builder.dataset.goal || 4);
    const currentVariant = builder.dataset.currentVariant;
    const slots = qsa('[data-builder-slot]', builder);
    const picker = qs('[data-builder-picker]', builder);
    const submit = qs('[data-builder-submit]', builder);
    const message = qs('[data-builder-message]', builder);
    const progress = qs('[data-builder-progress]', builder);
    const markers = qsa('.pdp-builder__progress > i', builder);
    let activeSlot = null;

    const selectedSlots = () => slots.filter((slot) => slot.dataset.variantId);
    const total = () => 1 + selectedSlots().length;
    const paint = () => {
      const count = total();
      if (progress) progress.style.width = `${Math.min(100, (count / goal) * 100)}%`;
      markers.forEach((marker, index) => marker.classList.toggle('is-filled', count > index));
      if (message) {
        message.textContent = count >= goal
          ? 'Kampanya hazır · 1 ürün bizden'
          : `${goal - count} ürün daha seç, 1 ürün bizden`;
      }
      if (submit) {
        submit.textContent = count >= goal
          ? `${count} ürünü sepete ekle · 1 ürün bizden`
          : `${count} ürünü sepete ekle`;
      }
    };

    builder.addEventListener('click', async (e) => {
      const slot = e.target.closest('[data-builder-slot]');
      if (slot) {
        activeSlot = slot;
        if (picker?.showModal) picker.showModal();
        return;
      }

      const choice = e.target.closest('[data-builder-choice]');
      if (choice && activeSlot) {
        activeSlot.dataset.variantId = choice.dataset.variantId;
        activeSlot.classList.add('is-selected');
        const media = qs('[data-builder-slot-media]', activeSlot);
        const title = qs('[data-builder-slot-title]', activeSlot);
        const price = qs('[data-builder-slot-price]', activeSlot);
        const action = qs('[data-builder-slot-action]', activeSlot);
        if (media) {
          media.textContent = '';
          if (choice.dataset.imageSrc) {
            const image = document.createElement('img');
            image.src = choice.dataset.imageSrc;
            image.alt = choice.dataset.productTitle || '';
            media.appendChild(image);
          }
        }
        if (title) title.textContent = choice.dataset.productTitle || 'Seçilen ürün';
        if (price) price.textContent = choice.dataset.productPrice || '';
        if (action) action.textContent = 'Değiştir';
        picker.close();
        activeSlot = null;
        paint();
        return;
      }

      if (e.target.closest('[data-builder-picker-close]')) {
        picker?.close();
        activeSlot = null;
        return;
      }

      if (!e.target.closest('[data-builder-submit]') || !submit || total() === 0) return;
      const quantities = new Map([[currentVariant, 1]]);
      selectedSlots().forEach((selected) => {
        const id = selected.dataset.variantId;
        quantities.set(id, (quantities.get(id) || 0) + 1);
      });
      const items = [...quantities.entries()].map(([id, quantity]) => ({
        id: Number(id),
        quantity
      }));
      submit.classList.add('is-loading');
      submit.disabled = true;
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('Cart add failed');
        await refreshCart();
        openDrawer('#CartDrawer');
      } finally {
        submit.classList.remove('is-loading');
        paint();
      }
    });

    picker?.addEventListener('click', (e) => {
      if (e.target !== picker) return;
      picker.close();
      activeSlot = null;
    });

    paint();
  });

  /* Search */
  const searchInput = qs('[data-predictive-search]');
  if (searchInput) {
    let t;
    searchInput.addEventListener('input', () => {
      clearTimeout(t);
      t = setTimeout(async () => {
        const q = searchInput.value.trim();
        const box = qs('[data-search-results]');
        if (!q || q.length < 2) { if (box) box.innerHTML = ''; return; }
        const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`);
        const json = await res.json();
        const products = json.resources?.results?.products || [];
        box.innerHTML = products.map((p) => `
          <a class="cart-item" href="${p.url}">
            <img src="${p.image || ''}" alt="">
            <div><div>${p.title}</div><div>${p.price}</div></div>
          </a>`).join('') || `<p>${box.dataset.empty}</p>`;
      }, 180);
    });
  }

  /* Slideshow — fade + swipe, mobile-first */
  qsa('[data-slideshow]').forEach((root) => {
    const slides = qsa('[data-slide]', root);
    const dots = qsa('[data-dot]', root);
    if (!slides.length) return;
    let i = 0;
    let timer;
    const interval = Math.max(4, Number(root.dataset.interval || 7)) * 1000;
    const show = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, idx) => s.classList.toggle('is-active', idx === i));
      dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
    };
    const stop = () => clearInterval(timer);
    const start = () => {
      stop();
      if (slides.length < 2) return;
      timer = setInterval(() => show(i + 1), interval);
    };
    show(0);
    start();
    root.addEventListener('click', (e) => {
      if (e.target.closest('[data-next]')) { show(i + 1); start(); }
      if (e.target.closest('[data-prev]')) { show(i - 1); start(); }
      const dot = e.target.closest('[data-dot]');
      if (dot) { show(Number(dot.dataset.dot)); start(); }
    });
    let x0 = null;
    root.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      x0 = e.clientX;
      stop();
    });
    root.addEventListener('pointerup', (e) => {
      if (x0 == null) return;
      const dx = e.clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 40) show(i + (dx < 0 ? 1 : -1));
      start();
    });
    root.addEventListener('pointerleave', () => { if (x0 != null) { x0 = null; start(); } });
  });

  /* Announcement rotator */
  qsa('[data-announce]').forEach((root) => {
    const msgs = qsa('[data-announce-msg]', root);
    if (msgs.length < 2) return;
    let i = 0;
    const show = (n) => {
      i = (n + msgs.length) % msgs.length;
      msgs.forEach((m, idx) => m.hidden = idx !== i);
    };
    show(0);
    root.addEventListener('click', (e) => {
      if (e.target.closest('[data-next]')) show(i + 1);
      if (e.target.closest('[data-prev]')) show(i - 1);
    });
    setInterval(() => show(i + 1), 4000);
  });

  /* Quantity on PDP */
  document.addEventListener('click', (e) => {
    const wrap = e.target.closest('[data-qty]');
    if (!wrap) return;
    const input = wrap.querySelector('input');
    if (e.target.closest('[data-qty-minus]')) input.stepDown();
    if (e.target.closest('[data-qty-plus]')) input.stepUp();
  });

  /* Product gallery thumbnails */
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-product-thumb]');
    if (!thumb || !thumb.dataset.imageSrc) return;
    const gallery = thumb.closest('[data-product-gallery]');
    const main = gallery?.querySelector('[data-product-main-image]');
    if (!main) return;
    main.src = thumb.dataset.imageSrc;
    main.alt = thumb.dataset.imageAlt || '';
    qsa('[data-product-thumb]', gallery).forEach((item) => {
      item.classList.toggle('is-active', item === thumb);
    });
  });

  /* Accordions — soft height and opacity transitions */
  qsa('.pdp-accordions details, .pdp-faq details, .accordion details, .faq-simple__list details').forEach((details) => {
    const summary = qs('summary', details);
    const content = [...details.children].find((child) => child !== summary);
    if (!summary || !content) return;
    let animation;
    let expanded = details.open;

    summary.addEventListener('click', (event) => {
      event.preventDefault();
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        expanded = !expanded;
        details.open = expanded;
        return;
      }

      const opening = !expanded;
      expanded = opening;
      // Closed <details> content stays laid out under content-visibility:hidden,
      // so its box is already full height. Animate from 0 in that case.
      const collapsed = !details.open && getComputedStyle(details, '::details-content').contentVisibility === 'hidden';
      const startHeight = collapsed ? 0 : content.getBoundingClientRect().height;
      animation?.cancel();
      if (opening) details.open = true;
      const endHeight = opening ? content.scrollHeight : 0;
      content.style.overflow = 'hidden';
      details.classList.add('is-animating');

      animation = content.animate(
        [
          { height: `${startHeight}px`, opacity: opening && startHeight === 0 ? 0 : 1, transform: opening && startHeight === 0 ? 'translateY(-7px)' : 'translateY(0)' },
          { height: `${endHeight}px`, opacity: opening ? 1 : 0, transform: opening ? 'translateY(0)' : 'translateY(-7px)' }
        ],
        { duration: 520, easing: 'cubic-bezier(.16,1,.3,1)' }
      );

      animation.onfinish = () => {
        if (!opening) details.open = false;
        ['height', 'opacity', 'transform', 'overflow'].forEach((property) => content.style.removeProperty(property));
        details.classList.remove('is-animating');
        animation = null;
      };
    });
  });

  /* Product ingredients — rear label PDF dialog */
  document.addEventListener('click', (event) => {
    const zoom = event.target.closest('[data-label-pdf-zoom]');
    if (zoom) {
      zoom.classList.toggle('is-zoomed');
      return;
    }

    const opener = event.target.closest('[data-label-pdf-open]');
    if (opener) {
      const dialog = document.getElementById(opener.getAttribute('aria-controls'));
      if (!dialog) return;
      dialog.querySelector('[data-label-pdf-zoom]')?.classList.remove('is-zoomed');
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      return;
    }

    const closer = event.target.closest('[data-label-pdf-close]');
    if (closer) {
      const dialog = closer.closest('[data-label-pdf-dialog]');
      if (typeof dialog?.close === 'function') dialog.close();
      else dialog?.removeAttribute('open');
      return;
    }

    const dialog = event.target.closest('[data-label-pdf-dialog]');
    if (dialog && event.target === dialog) dialog.close();
  });

  /* Variant */
  document.addEventListener('change', (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    const select = form.querySelector('[name="id"]');
    const json = qs('[data-product-json]', form);
    if (!json || !select) return;
    const product = JSON.parse(json.textContent);
    const values = qsa('[data-option]', form).map((el) => {
      if (el.type === 'radio') {
        const checked = form.querySelector(`[name="${el.name}"]:checked`);
        return checked ? checked.value : '';
      }
      return el.value;
    }).filter(Boolean);
    const variant = product.variants.find((v) => values.every((val) => v.options.includes(val))) || product.variants[0];
    if (variant) {
      select.value = variant.id;
      const price = form.closest('.product')?.querySelector('[data-price]');
      if (price) price.innerHTML = formatMoney(variant.price);
      const btn = form.querySelector('[type="submit"]');
      if (btn) {
        btn.disabled = !variant.available;
        btn.textContent = variant.available ? theme.strings.addToBag : theme.strings.soldOut;
      }
    }
  });

  /* Before / after */
  qsa('[data-ba]').forEach((root) => {
    const after = qs('[data-ba-after]', root);
    const handle = qs('[data-ba-handle]', root);
    const set = (pct) => {
      after.style.width = pct + '%';
      handle.style.left = pct + '%';
    };
    const move = (x) => {
      const rect = root.getBoundingClientRect();
      set(Math.min(96, Math.max(4, ((x - rect.left) / rect.width) * 100)));
    };
    root.addEventListener('pointerdown', (e) => {
      root.setPointerCapture(e.pointerId);
      move(e.clientX);
    });
    root.addEventListener('pointermove', (e) => {
      if (e.buttons) move(e.clientX);
    });
  });

  /* Tabs */
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-tab]');
    if (!tab) return;
    const group = tab.closest('[data-tabs]');
    qsa('[data-tab]', group).forEach((t) => t.classList.toggle('is-active', t === tab));
    qsa('[data-tab-panel]', group).forEach((p) => {
      const on = p.dataset.tabPanel === tab.dataset.tab;
      p.hidden = !on;
      p.classList.toggle('is-hidden', !on);
      if (on) qsa('.reveal', p).forEach((el) => el.classList.add('is-in'));
    });
  });

  /* Accordion FAQ nav */
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-faq-jump]');
    if (!link) return;
    e.preventDefault();
    qs(link.getAttribute('href'))?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* Scroll top */
  const topBtn = qs('[data-scroll-top]');
  if (topBtn) {
    window.addEventListener('scroll', () => {
      topBtn.classList.toggle('is-visible', window.scrollY > 600);
    }, { passive: true });
    topBtn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  /* Newsletter popup — skip on phones so the slideshow stays first */
  const popup = qs('#NewsletterPopup');
  const isPhone = window.matchMedia('(max-width: 749px)').matches;
  if (popup && !isPhone && !sessionStorage.getItem('aurelia-popup')) {
    setTimeout(() => popup.classList.add('is-open'), 4000);
    popup.addEventListener('click', (e) => {
      if (e.target.closest('[data-close-popup]') || e.target === popup) {
        popup.classList.remove('is-open');
        sessionStorage.setItem('aurelia-popup', '1');
      }
    });
  }

  /* Quiz */
  qsa('[data-quiz]').forEach((form) => {
    const steps = qsa('[data-quiz-step]', form);
    const result = qs('[data-quiz-result]', form);
    const progress = qs('[data-quiz-progress]', form);
    let catalog = [];
    try { catalog = JSON.parse(qs('[data-quiz-map]', form)?.textContent || '[]'); } catch (err) { catalog = []; }
    let i = 0;
    const paintProgress = (all) => {
      if (!progress) return;
      progress.innerHTML = steps.map((_, n) => `<span class="${all || n <= i ? 'is-on' : ''}"></span>`).join('');
    };
    const show = () => {
      steps.forEach((s, idx) => { s.hidden = idx !== i; });
      if (result) result.hidden = true;
      paintProgress(false);
    };
    const pick = () => {
      const answers = qsa('input:checked', form).map((el) => el.value.trim());
      let best = catalog[0];
      let score = -1;
      catalog.forEach((item) => {
        const n = (item.keys || []).filter((k) => answers.includes(k)).length;
        if (n > score) { score = n; best = item; }
      });
      return best;
    };
    const finish = () => {
      const best = pick();
      if (!result || !best) return;
      steps.forEach((s) => { s.hidden = true; });
      result.hidden = false;
      const title = qs('[data-quiz-title]', result);
      const price = qs('[data-quiz-price]', result);
      const why = qs('[data-quiz-why]', result);
      const img = qs('[data-quiz-img]', result);
      const cta = qs('[data-quiz-cta]', result);
      if (title) title.textContent = best.title;
      if (price) price.textContent = best.price || '';
      if (why) why.textContent = best.why || '';
      if (img) { img.src = best.img; img.alt = best.title; }
      if (cta && best.handle) cta.href = `${window.Shopify?.routes?.root || '/'}products/${best.handle}`;
      paintProgress(true);
    };
    form.addEventListener('submit', (e) => e.preventDefault());
    show();
    form.addEventListener('click', (e) => {
      if (e.target.closest('[data-quiz-next]')) {
        if (!steps[i]?.querySelector('input:checked')) return;
        i = Math.min(steps.length - 1, i + 1);
        show();
      }
      if (e.target.closest('[data-quiz-prev]')) {
        i = Math.max(0, i - 1);
        show();
      }
      if (e.target.closest('[data-quiz-finish]')) {
        if (!steps[i]?.querySelector('input:checked')) return;
        finish();
      }
      if (e.target.closest('[data-quiz-restart]')) {
        i = 0;
        form.reset();
        show();
      }
    });
  });

  /* Scroll reveal */
  const motionOk = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (motionOk && 'IntersectionObserver' in window) {
    qsa('.product-grid, .cat-grid, .feed-grid, .look-grid, .compare-cards, .multi-grid, .funnel-path__steps, .quote-grid').forEach((grid) => {
      if (grid.hidden || grid.classList.contains('is-hidden')) return;
      [...grid.children].forEach((el, n) => {
        el.classList.add('reveal');
        el.style.setProperty('--reveal-delay', `${n * 80}ms`);
      });
    });
    qsa('.section-head, .rte-center, .quiz, .sales-banner__copy, .overlay-banner__copy, .ba, .funnel-path__head, .split-grid > *, .compare').forEach((el) => {
      el.classList.add('reveal');
    });
    const rio = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        entry.target.closest('.funnel-path')?.classList.add('is-in');
        rio.unobserve(entry.target);
      });
    }, { threshold: 0.01, rootMargin: '0px 0px 18% 0px' });
    const inView = (el) => {
      const r = el.getBoundingClientRect();
      return r.top < window.innerHeight * 0.98 && r.bottom > 24;
    };
    qsa('.reveal').forEach((el) => {
      if (inView(el)) {
        el.classList.add('is-in');
        el.closest('.funnel-path')?.classList.add('is-in');
      }
      rio.observe(el);
    });
    const flushReveal = () => {
      qsa('.reveal:not(.is-in)').forEach((el) => {
        if (inView(el)) {
          el.classList.add('is-in');
          el.closest('.funnel-path')?.classList.add('is-in');
        }
      });
    };
    window.addEventListener('scroll', flushReveal, { passive: true });
    setTimeout(flushReveal, 700);
  }

  /* Funnel bar + active step */
  const bar = qs('[data-funnel-bar]');
  if (bar) {
    const links = qsa('a', bar);
    const markLink = (hash) => {
      links.forEach((a) => a.classList.toggle('is-on', a.getAttribute('href') === hash));
    };
    const steps = qsa('[data-funnel-step]');
    const markStep = (n) => steps.forEach((s) => s.classList.toggle('is-on', Number(s.dataset.funnelStep) === n));
    if ('IntersectionObserver' in window) {
      const fio = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          markLink({
            'funnel-cats': '#funnel-catalog',
            'funnel-catalog': '#funnel-catalog',
            'funnel-compare': '#funnel-catalog',
            'funnel-quiz': '#funnel-quiz',
            'funnel-offer': '#funnel-offer'
          }[entry.target.id] || ('#' + entry.target.id));
          markStep(Number(entry.target.dataset.funnelMark || 0));
        });
      }, { threshold: 0.28 });
      [
        ['funnel-cats', 2],
        ['funnel-catalog', 2],
        ['funnel-quiz', 1],
        ['funnel-compare', 2],
        ['funnel-offer', 3]
      ].forEach(([id, n]) => {
        const el = document.getElementById(id);
        if (!el) return;
        el.dataset.funnelMark = String(n);
        fio.observe(el);
      });
    }
    const toggleBar = () => {
      const show = window.scrollY > window.innerHeight * 0.4;
      bar.hidden = !show;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('has-funnel-bar', show);
    };
    window.addEventListener('scroll', toggleBar, { passive: true });
    toggleBar();
  }

  /* Key ingredients — tap reveals color on phones (no hover) */
  document.addEventListener('click', (e) => {
    const swatch = e.target.closest('[data-ingredients] .ing-swatch');
    if (!swatch) return;
    const root = swatch.closest('[data-ingredients]');
    qsa('.ing-swatch', root).forEach((el) => el.classList.toggle('is-on', el === swatch));
    const input = swatch.querySelector('input');
    if (input) input.checked = true;
  });

  /* Legal center, checkout confirmation and cookie preferences */
  const legalDialog = qs('#LegalCenter');
  const showLegalDocument = (name) => {
    if (!legalDialog) return;
    qsa('[data-legal-document]', legalDialog).forEach((documentPanel) => {
      documentPanel.hidden = documentPanel.dataset.legalDocument !== name;
    });
    qsa('[data-legal-tab]', legalDialog).forEach((tab) => {
      const active = tab.dataset.legalTab === name;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-current', active ? 'page' : 'false');
    });
    if (!legalDialog.open) legalDialog.showModal();
    qs('.legal-dialog__content', legalDialog)?.scrollTo({ top: 0 });
  };

  document.addEventListener('click', (e) => {
    const legalOpen = e.target.closest('[data-legal-open]');
    if (legalOpen) {
      e.preventDefault();
      showLegalDocument(legalOpen.dataset.legalOpen || 'kvkk');
      return;
    }
    const legalTab = e.target.closest('[data-legal-tab]');
    if (legalTab) {
      showLegalDocument(legalTab.dataset.legalTab);
      return;
    }
    if (e.target.closest('[data-legal-close]')) {
      legalDialog?.close();
      return;
    }
    if (e.target === legalDialog) legalDialog.close();
  });

  document.addEventListener('change', (e) => {
    const consent = e.target.closest('[data-checkout-consent]');
    if (!consent) return;
    const checkout = qs('[data-checkout-link]');
    checkout?.classList.toggle('is-disabled', !consent.checked);
    checkout?.setAttribute('aria-disabled', consent.checked ? 'false' : 'true');
  });

  document.addEventListener('click', (e) => {
    const checkout = e.target.closest('[data-checkout-link]');
    if (!checkout || checkout.getAttribute('aria-disabled') !== 'true') return;
    e.preventDefault();
    const consent = qs('[data-checkout-consent]');
    consent?.focus();
  });

  const cookieConsent = qs('[data-cookie-consent]');
  const cookieStorageKey = 'saint-clair-cookie-consent';
  const readCookieChoice = () => {
    try { return localStorage.getItem(cookieStorageKey); } catch (err) { return null; }
  };
  const saveCookieChoice = (choice) => {
    try { localStorage.setItem(cookieStorageKey, choice); } catch (err) {}
  };
  const applyCookieChoice = (accepted) => {
    const privacy = window.Shopify?.customerPrivacy;
    if (privacy?.setTrackingConsent) {
      privacy.setTrackingConsent(accepted, () => {});
    }
    saveCookieChoice(accepted ? 'accepted' : 'necessary');
    if (cookieConsent) cookieConsent.hidden = true;
  };

  if (cookieConsent && !readCookieChoice()) {
    window.setTimeout(() => {
      const privacy = window.Shopify?.customerPrivacy;
      if (!privacy?.shouldShowBanner || privacy.shouldShowBanner()) cookieConsent.hidden = false;
    }, 500);
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cookie-accept]')) applyCookieChoice(true);
    if (e.target.closest('[data-cookie-reject]')) applyCookieChoice(false);
    if (e.target.closest('[data-cookie-settings]') && cookieConsent) {
      cookieConsent.hidden = false;
    }
  });

  refreshCart().catch(() => {});
})();
